import { observer } from 'mobx-react-lite';
import ProposalSection, { ProposalSectionEditableProps } from '../ProposalSection';
import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto';
import Stack from "@mui/material/Stack"
import useStore from 'reusable/mobx-store-utils';
import ProposalSectionPricingStore, { ProposalSectionPricingStoreProvider } from './ProposalSectionPricingStore';
import ProposalSectionPricingCategoryCard from './ProposalSectionPricingCategoryCard';
import { useProposalsViewStore } from 'features/proposals/ProposalsViewStore';

interface ProposalSectionPricingProps {
   proposal: ProposalDto,
   sectionProps?: ProposalSectionEditableProps,
   filteredServiceIds?: string[],
   /** There are some nuances if this is an advisor previewing their proposal */
   showPreviewHints?: boolean,
}

export default observer(function ProposalSectionPricing({ proposal, sectionProps, filteredServiceIds, showPreviewHints }: ProposalSectionPricingProps) {
   const proposalsViewStore = useProposalsViewStore()
   const proposalSectionPricingStore = useStore((sp) => new ProposalSectionPricingStore(sp), { proposal, filteredServiceIds, proposalsViewStore })
   const { pricing } = proposalSectionPricingStore

   return (
      <ProposalSectionPricingStoreProvider store={proposalSectionPricingStore}>
         <ProposalSection heading="Pricing & Payment Terms" {...sectionProps}>
            <Stack sx={{ gap: 8 }}>
               {pricing?.map((pricingItem, index) => <ProposalSectionPricingCategoryCard {...{ pricingItem, showPreviewHints }} key={index} />)}
            </Stack>
         </ProposalSection>
      </ProposalSectionPricingStoreProvider>
   )
})
